<script>
  import { getSrc, getSrcTest } from "./UmlCompress.js";
  import { toHex, md5 } from "../util.js";

  export let quest;

  let uml = `
(Use the application) as (t1)

(Вторая задача) as (t2)
(Третья  2 задача) as (t32)
(Третья 3 задача) as (t33)
(Третья задача) as (t3)
t1 --> t2
t1 --> t3
t3 --> t32
t3 --> t33

`;

  // $: src = getSrc(toUml(quest));
  $: src = getSrc(toUmlStateDiagram(quest));

  function addColor() {
    // let result = `skinparam usecase {\n
    let result = `skinparam state {\n
        ArrowColor Orange\n
        FontColor White\n
        shadowing false\n
        \n`;
    for (let i = 0; i < quest.tasks.length; i++) {
      const task = quest.tasks[i];
      result += "BackgroundColor<<" + md5(task.id) + ">> " + (task.bgcolor || toHex(task.name)) + "\n";
      // result += "classFontColor<<" + md5(task.id) + ">> " + "#ffffff" + "\n";
      result += "BorderColor<<" + md5(task.id) + ">> " + (task.bgcolor || toHex(task.name)) + "\n";
      result += "shadowing<<" + md5(task.id) + ">> " + "false" + "\n";
    }
    result += "}\n";

    // for (let i = 0; i < quest.tasks.length; i++) {
    //   const task = quest.tasks[i];
    //   result += "skinparam " + task.id + " {\n"
    //   result += "BackgroundColor " + toHex(task.name) + "\n";
    //   result += "BorderColor " + toHex(task.name) + "\n";
    //   result += "shadowing " + "false" + "\n";
    //   result += "}\n";
    // }

    return result;
  }

  function _toUml_del() {
    // let result = "skinparam handwritten true\n";
    let result = addColor();
    // result += "skinparam shadowing false\n";
    for (let i = 0; i < quest.tasks.length; i++) {
      const task = quest.tasks[i];
      //   result += "(" + task.name + ") as (" + task.id + ")\n";
      result +=
        "(" + task.name + ") as (" + md5(task.id) + ") <<" + md5(task.id) + ">>" + "\n";
    }
    for (let i = 0; i < quest.tasks.length; i++) {
      const task = quest.tasks[i];
      for (let ti = 0; ti < task.next.length; ti++) {
        const tn = task.next[ti];
        result += md5(task.id) + " --> " + tn + "\n";
      }
    }
    return result;
  }

  function _toUmlStateDiagram_old() {
    let result = addColor();
    for (let i = 0; i < quest.tasks.length; i++) {
      const task = quest.tasks[i];
      result +=
        'state "' +
        task.name +
        '" as ' +
        md5(task.id) +
        " <<" +
        md5(task.id) +
        ">>" +
        "\n";
    }
    for (let i = 0; i < quest.tasks.length; i++) {
      const task = quest.tasks[i];
      if (task.next) for (let ti = 0; ti < task.next.length; ti++) {
        let tn = task.next[ti];
        tn = md5(tn);
        result += md5(task.id) + " --> " + tn + "\n";
      }
      if (task.tips) for (let tipId = 0; tipId < task.tips.length; tipId++) {
        const id = task.tips[tipId];
        const tip = quest.tips.find(t => t.id == id);
        result += tip ? md5(task.id) + " : " + tip.name + "\n" : '';
      }
    }
    return result;
  }

  function toUmlStateDiagram() {
    let result = addColor();
    for (let i = 0; i < quest.tasks.length; i++) {
      const task = quest.tasks[i];
      result +=
        'state "' +
        task.name +
        '" as ' +
        md5(task.id) +
        " <<" +
        md5(task.id) +
        ">>" +
        "\n";
    }
    for (let i = 0; i < quest.tasks.length; i++) {
      const task = quest.tasks[i];
      if (task.prev) for (let ti = 0; ti < task.prev.length; ti++) {
        let tn = task.prev[ti];
        tn = md5(tn);
        result += tn + " --> " + md5(task.id) + "\n";
      }
      if (task.tips) for (let tipId = 0; tipId < task.tips.length; tipId++) {
        const id = task.tips[tipId];
        const tip = quest.tips.find(t => t.id == id);
        result += tip ? md5(task.id) + " : " + tip.name + "\n" : '';
      }
    }
    return result;
  }
</script>

<div />
<img {src} alt="test" />
<br />

<!-- {#each quest.tasks as task}
  {task.id}
  <br />
{/each}
{toUml()} -->
